<script>
	import API from '../../States/API';
	import Config from '../../Models/Config';
	import Data from '../../States/Data';
	import Helper from '../../Models/Helper';
	import Session from '../../States/Session';
	import Slider from '../../States/Slider';

	let active = false;
	let selected = '';

	Slider.subscribe(slides => {
		if (active)
			Session.updateMenu(false);

		switch (slides.active.properties.type) {
			case 'chapter': selected = 'read'; break;
			case 'books': case 'chapters': selected = 'browse'; break;
			default: selected = slides.active.properties.type; break;
		}
	});

	Session.subscribe(state => {
		active = state.menu.active;
	});
</script>

<style>
	#menu {
		font-size: 1.25em;
		margin-top: 2em;
		margin-left: 10vw;
		padding-top: 1em;
		max-width: 20vw;
		opacity: 0;
		transition: opacity .3s ease-out;
		will-change: opacity;
	}

	#menu.active {
		opacity: 1;
	}

	div.profile {
		cursor: pointer;
	}

	div.profile div.initials {
		display: inline-block;
		font-weight: bold;
		text-align: center;
		color: var(--tertiary-color);
		border-radius: .5em;
		padding: 1em;
		min-width: 3.3em;
		background: var(--box-background-focus);
	}

	div.profile div.name {
		display: inline-block;
		vertical-align: top;
		padding: .5em .8em;
	}

	div.profile div.name span {
		display: block;
	}

	div.profile div.name span:first-child {
		font-size: 0.75em;
		color: var(--secondary-color);
		font-weight: 400;
	}

	div.profile div.name span:last-child {
		font-size: 1.2em;
		line-height: 1.1em;
		color: var(--primary-color);
	}

	div.navigation {
		margin-top: 1em;
	}

	div.navigation > a,
	div.navigation > div {
		display: block;
		text-decoration: none;
		padding: 1em 1em 1em 0;
		margin-left: -1.25em;
		border-top-left-radius: .5em;
		border-bottom-left-radius: .5em;
		border-bottom: 1px solid rgba(0, 0, 0, .05);
		cursor: pointer;
	}

	:global(html.dark) #menu div.navigation > a,
	:global(html.dark) #menu div.navigation > div {
		border-bottom: 1px solid rgba(0, 0, 0, .15);
	}

	:global(html.light) #menu div.navigation > a.active,
	:global(html.light) #menu div.navigation > div.active {
		background: rgba(255, 255, 255, .75);
	}

	:global(html.dark) #menu div.navigation > a.active,
	:global(html.dark) #menu div.navigation > div.active {
		background: rgba(0, 0, 0, .2);
	}

	div.navigation > a i,
	div.navigation > div i {
		font-size: 1.25em;
		text-align: center;
		vertical-align: middle;
		width: 1.25em;
		color: var(--tertiary-color);
		margin-left: 1em;
		margin-right: .5em;
	}

	div.navigation > a span,
	div.navigation > div span {
		font-size: 1em;
		font-weight: 700;
		vertical-align: middle;
		opacity: .9;
	}

	div.social {
		text-align: center;
		padding-top: 3em;
	}

	div.social > a {
		display: inline-block;
		margin: 0 .6em;
	}

	div.social > a i {
		font-size: 1.3em;
		color: var(--tertiary-color);
		opacity: .75;
	}

	@media (max-device-width: 768px) {
		#menu {
			margin-top: 0;
		}
	}

	@media (max-device-width: 1024px) {
		#menu {
			font-size: 1em;
			margin-left: 6vw;
			max-width: 54vw;
		}
	}

	@media (min-device-width: 768px) and (max-device-width: 1024px) {
		#menu {
			max-width: 31vw;
			margin-top: 2em;
		}
	}
</style>

<div id="menu" class:active>
	{#if $API.active}
		<div on:click="{event => Slider.route($Session.authentication.active ? 'profile' : 'signIn')}" class="profile">
			<div class="initials">
				<span>{$Session.authentication.active ? $Session.user.initials : 'G'}</span>
			</div>
			<div class="name">
				<span>Welkom!</span>
				<span>{$Session.authentication.active ? $Session.user.name : 'Gast'}</span>
			</div>
		</div>
	{/if}
	<div class="navigation">
		<div on:click="{event => Slider.route('start')}" class:active="{['', 'start'].includes(selected)}">
			<i class="fad fa-home-alt"></i>
			<span>Start</span>
		</div>
		<div on:click="{event => Slider.route('read')}" class:active="{selected == 'read'}">
			<i class="fad fa-book-open"></i>
			<span>Lezen</span>
		</div>
		<div on:click="{event => Slider.route('search')}" class:active="{selected == 'search'}">
			<i class="fad fa-search"></i>
			<span>Zoeken</span>
		</div>
		<a href="/oude-testament" class:active="{selected == 'browse'}">
			<i class="fad fa-books"></i>
			<span>Boek kiezen</span>
		</a>
		{#if $Session.authentication.active}
			<div on:click="{event => Slider.route('favorite')}" class:active="{selected == 'favorite'}">
				<i class="fad fa-book-heart"></i>
				<span>Favorieten</span>
			</div>
		{/if}
		{#if $Session.authentication.active}
			{#if $API.active}
				<div on:click="{event => Slider.signOut()}">
					<i class="fad fa-sign-out"></i>
					<span>Uitloggen</span>
				</div>
			{/if}
		{:else if $API.active}
			<div on:click="{event => Slider.route('signIn')}" class:active="{selected == 'sign_in'}">
				<i class="fad fa-sign-in"></i>
				<span>Inloggen</span>
			</div>
		{/if}
		{#if !$Data.version.beta}
			<div on:click="{event => Slider.route('help')}" class:active="{selected == 'help'}">
				<i class="fad fa-question-circle"></i>
				<span>Help</span>
			</div>
		{/if}
		<div on:click="{event => Slider.route('info')}" class:active="{selected == 'info'}">
			<i class="fad fa-info-circle"></i>
			<span>Info &amp; Contact</span>
		</div>
		{#if $API.active && $Data.version.paypal && !Helper.app()}
			<div on:click="{event => window.open(Config.paypal)}">
				<i class="far fa-euro-sign"></i>
				<span>Giften via PayPal</span>
			</div>
		{/if}
	</div>
	{#if $API.active && $Data.version.beta}
		<div class="social">
			<a href="https://facebook.com/BasisBijbel" target="_blank">
				<i class="fab fa-facebook"></i>
			</a>
			<a href="https://instagram.com/basisbijbel" target="_blank">
				<i class="fab fa-instagram"></i>
			</a>
		</div>
	{/if}
</div>